import { PageLayout } from "@/components/layout/PageLayout";
import { Helmet } from "react-helmet-async";
import { CopyTrading as CopyTradingComponent } from "@/components/social/CopyTrading";
import { UserCheck, TrendingUp, Shield, Zap } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function CopyTrading() {
  return (
    <>
      <Helmet>
        <title>Copy Trading - TheMoonRun</title>
        <meta name="description" content="Copy successful traders on TheMoonRun. Auto-mirror trades from top performers." />
      </Helmet>
      
      <PageLayout>
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20 flex items-center justify-center">
              <UserCheck className="w-7 h-7 text-blue-500" />
            </div>
            <div>
              <h1 className="text-2xl font-display font-bold text-foreground">Copy Trading</h1>
              <p className="text-muted-foreground">Follow and auto-mirror top traders</p>
            </div>
          </div>
          <div className="flex gap-2">
            <Badge variant="secondary">Beta</Badge>
            <Button variant="outline" size="sm" asChild>
              <Link to="/copy-subscriptions">Manage Subscriptions</Link>
            </Button>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
          {[
            { icon: TrendingUp, label: "Top Performers", desc: "Verified track record", color: "text-green-500" },
            { icon: Zap, label: "Auto Mirror", desc: "Instant copy trades", color: "text-yellow-500" },
            { icon: Shield, label: "Risk Controls", desc: "Set your limits", color: "text-blue-500" },
            { icon: UserCheck, label: "Transparent", desc: "Full trade history", color: "text-purple-500" },
          ].map((feature, i) => (
            <div key={i} className="p-3 sm:p-4 rounded-xl bg-card border border-border">
              <feature.icon className={`w-5 h-5 ${feature.color} mb-2`} />
              <p className="text-sm font-semibold text-foreground">{feature.label}</p>
              <p className="text-xs text-muted-foreground">{feature.desc}</p>
            </div>
          ))}
        </div>

        <CopyTradingComponent />
      </PageLayout>
    </>
  );
}
